import axios from 'axios';
import { stringify } from 'qs';
import submitToSf from './sf-file-upload';
import { closePopups, openPopups, openSecondaryPopups } from '../../utils';

const showFailMessage = () => {
    const formButton = document.querySelector('form .btn.submit');
    if (formButton) {
        formButton.insertAdjacentHTML('beforebegin', `
            <p class="my-lg text--orange heavy">Something went wrong. Please try again later.<p>
        `);
        formButton.classList.remove('btn--loading');
    }
};

export default (form) => {
    const formButton = form.querySelector('.btn.submit');
    form.addEventListener('submit', (e) => {
        e.preventDefault();
        const data = {};
        //disable button
        formButton.classList.add('btn--disabled');
        formButton.classList.add('btn--loading');
        form.dataset.ajaxFields.split(',').forEach((inputField) => {
            const field = form.querySelector(`[name="${inputField}"]`);
            data[inputField] = field ? field.value : null;
        });

        const post = {
            method: 'post',
            url: '/actions/e7project/application/post-application',
            data: stringify(data),
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                'X-CSRF-Token': window.csrfTokenValue,
            },
        };
        let invoiceId = null;
        axios(post)
            .then((response) => {
                /* eslint-disable no-console */
                if (!response.data.success) {
                    showFailMessage();
                    throw new Error('Failed to retreive IDs');
                }
                invoiceId = response.data.invoiceId;
                const submissions = [];
                response.data.applicationId.forEach((appId, index) => {
                    submissions.push(submitToSf(appId, index > 0 ? `.js-file-upload${index} input` : undefined));
                });
                return Promise.all(submissions);
            })
            .then((response) => {
                /* eslint-disable no-console */
                console.log(response);
                if (invoiceId) {
                    window.location.href = `https://cecforms.tfaforms.net/4849453?tfa_39=${invoiceId}`;
                } else {
                    form.dispatchEvent(new Event('reset'));
                    closePopups();
                    if (document.querySelector('.js-popup-secondary')) {
                        openSecondaryPopups();
                    } else {
                        openPopups();
                    }
                    formButton.classList.remove('btn--loading');
                    //remove disable button
                    formButton.classList.remove('btn--disabled');
                }
            })
            .catch((error) => {
                /* eslint-disable no-console */
                console.log(error);
                showFailMessage();
                //remove disable button
                formButton.classList.remove('btn--disabled');
            });
    });
};
